import { ActivityMessage } from 'src/components/ActivityList/activity-list-item';
import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { buildClientEmailMessage } from './build-client-email-message';
import { buildClientMessage } from './build-client-message';
import { buildClientPhoneNumberMessage } from './build-client-phone-number-message';
import { buildClientToAddressMessage } from './build-client-to-address-message';

export const buildMessagesByType = (activity: ActivityFeed): ActivityMessage[] => {
  switch (activity.entity) {
    case 'Client':
      return buildClientMessage(activity);
    case 'ClientToAddress':
      return buildClientToAddressMessage(activity);
    case 'ClientEmail':
      return buildClientEmailMessage(activity);
    case 'ClientPhoneNumber':
      return buildClientPhoneNumberMessage(activity);
    default:
      return [];
  }
};
